// Note: types exposed from `index.d.ts`.
export {fromHtml} from './lib/index.js'
